/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".reset-success[_ngcontent-%COMP%]{position:absolute;left:50%;top:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);text-align:center;width:100%}.reset-success[_ngcontent-%COMP%]   ion-icon[_ngcontent-%COMP%]{font-size:64px;color:green}.reset-success[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{font-size:20px;color:#333}"];
export { styles as styles };
